import WidgetCO2 from '~/components/widgets/widget-co2.vue';
import WidgetTemperature from '~/components/widgets/widget-temperature.vue';
import WidgetHumidity from '~/components/widgets/widget-humidity.vue';
import WidgetPressure from '~/components/widgets/widget-pressure.vue';
import WidgetHistogram from '~/components/widgets/widget-histogram.vue';
import WidgetIcone from '~/components/widgets/widget-icone.vue';
import WidgetAeroScore from '~/components/widgets/widget-aero-score.vue';
import WidgetMap from '~/components/widgets/widget-map.vue';
import WidgetMoreInformation from '~/components/widgets/widget-more-info/widget-more-information.vue';
import WidgetStationList from '~/components/widgets/widget-station-list/widget-station-list.vue';
import WidgetDistribution from '~/components/widgets/widget-distribution.vue';

import { Widget, WidgetType } from '~/models/widget.model';

type WidgetEntry<T> = { component: T, widget: Widget};

class WidgetRegistry {

    private static _instance: WidgetRegistry | null = null;

    static getInstance(): WidgetRegistry {
        if (!WidgetRegistry._instance) {
            WidgetRegistry._instance = new WidgetRegistry();
        }
        return WidgetRegistry._instance;
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    private constructor() {
    }

    private components: {[widgetType: string]: WidgetEntry<unknown>} = {};

    register<T>(widget: Widget, component: T) {
        this.components[widget.type] = {component, widget};
    }

    unregister(widget: Widget) {
        delete this.components[widget.type];
    }

    getComponents<T>(): {[widget in string]?: T} {
        const components = {};
        Object.values(this.components).forEach((entry) => {
            components[entry.widget.type] = entry.component;
        });
        return components;
    }

    getWidgetsSpecifications(): Widget[] {
        return Object.values(this.components).map((entry) => entry.widget); 
    }
}

const registry: WidgetRegistry = WidgetRegistry.getInstance();

registry.register({ height: 1, width: 3, minWidth: 2, minHeight: 1, x: 0, y: 0, type: WidgetType.AQ_CO2 } as Widget, WidgetCO2);
registry.register({ height: 1, width: 2, minWidth: 2, minHeight: 1, x: 3, y: 0, type: WidgetType.TEMPERATURE } as Widget, WidgetTemperature);
registry.register({ height: 1, width: 2, minWidth: 2, minHeight: 1, x: 5, y: 0, type: WidgetType.HUMIDITY } as Widget, WidgetHumidity);
registry.register({ height: 1, width: 2, minWidth: 2, minHeight: 1, x: 7, y: 0, type: WidgetType.PRESSURE } as Widget, WidgetPressure);
registry.register({ height: 1, width: 9, minWidth: 3, minHeight: 1, x: 0, y: 2, type: WidgetType.HISTOGRAM } as Widget, WidgetHistogram);
registry.register({ height: 1, width: 3, minWidth: 2, minHeight: 1, x: 0, y: 4, type: WidgetType.ICONE } as Widget, WidgetIcone);
registry.register({ height: 1, width: 3, minWidth: 2, minHeight: 1, x: 3, y: 4, type: WidgetType.MORE_INFO } as Widget, WidgetMoreInformation);
registry.register({ height: 1, width: 3, minWidth: 3, minHeight: 1, x: 6, y: 4, type: WidgetType.MAP } as Widget, WidgetMap);
registry.register({ height: 3, width: 3, minWidth: 3, minHeight: 2, x: 9, y: 0, type: WidgetType.STATIONS } as Widget, WidgetStationList);
registry.register({ height: 1, width: 3, minWidth: 3, minHeight: 1, x: 0, y: 6, type: WidgetType.AERO_SCORE } as Widget, WidgetAeroScore);
registry.register({ height: 2, width: 3, minWidth: 3, minHeight: 2, x: 3, y: 6, type: WidgetType.DISTRIBUTION } as Widget, WidgetDistribution);

export default registry;

